"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIRPORT_KEYWORDS = void 0;
exports.isAirportAddress = isAirportAddress;
const legacy_enums_1 = require("@daytrip/legacy-enums");
exports.AIRPORT_KEYWORDS = [
    "airport",
    "airfield",
    "aeroporto",
    "aeropuerto",
    "flughafen",
    "aéroport",
    "letiště",
    "lotnisko",
    "airline",
    "letališče",
];
function isAirportAddress({ address, addressType, flightNumber }) {
    if (addressType === legacy_enums_1.LocationAddressType.Airport) {
        return true;
    }
    if (flightNumber && flightNumber.trim() !== "") {
        return true;
    }
    if (!address) {
        return false;
    }
    const addressLowerCase = address.toLowerCase();
    return exports.AIRPORT_KEYWORDS.some((keyword) => addressLowerCase.includes(keyword));
}
//# sourceMappingURL=isAirportAddress.js.map